import { Injectable } from "@angular/core";

@Injectable()
export class StaticMemoryService {

    public firstPage = "";
}
  
 